import { Fragment } from "react";

export function WizardStepper({
	step,
	total = 3,
	onStepClick,
}: {
	step: number;
	total?: number;
	onStepClick?: (stepIndex: number) => void;
}) {
	const safeTotal = Math.max(2, Math.floor(total));
	const safeStep = Math.min(Math.max(0, Math.floor(step)), safeTotal - 1);

	return (
		<div className='mx-auto w-full max-w-4xl px-4'>
			<div className='flex w-full items-center'>
				{Array.from({ length: safeTotal }, (_, idx) => {
					const isActiveOrDone = idx <= safeStep;
					const isDone = idx < safeStep;
					const isClickable = typeof onStepClick === "function";
					return (
						<Fragment key={idx}>
							{isClickable ? (
								<button
									type='button'
									onClick={() => onStepClick?.(idx)}
									className={
										"flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-sm font-semibold transition " +
										(isActiveOrDone
											? "bg-primary text-white"
											: "bg-[#b6b9bf] text-white")
									}
									aria-label={`Ir al paso ${idx + 1}`}
								>
									{idx + 1}
								</button>
							) : (
								<div
									className={
										"flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-sm font-semibold transition " +
										(isActiveOrDone
											? "bg-primary text-white"
											: "bg-[#b6b9bf] text-white")
									}
								>
									{idx + 1}
								</div>
							)}

							{idx < safeTotal - 1 ? (
								<div
									className={
										"mx-3 h-1 flex-1 rounded " +
										(isDone ? "bg-primary" : "bg-[#c4c7cc]")
									}
									aria-hidden='true'
								/>
							) : null}
						</Fragment>
					);
				})}
			</div>
		</div>
	);
}
